import React, {useState, useEffect} from 'react';
import {currentResource, labels} from '../../../util/utils';
import styled from 'styled-components';
import {useDispatch, useSelector} from 'react-redux';
import ReactSelect from '../../Common/SelectDropdown/SelectDropdown';
import ContentSwitcher from '../../Common/BaseComponentWrappers/MotifContentSwitcher';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import EllipseControl from '../../Common/EllipsesControl/EllipsesControl';
import {getITControlById} from '../../../actions/ITControl/itcontrolaction';
import {itControlApproachType} from '../../../util/uiconstants';
import Button from '../../Common/BaseComponentWrappers/MotifButton';
import Utility from '../../../util/utilityfunctions';

export function EditITControlContainer(props) {
	const {ADCContainerRef, isShared, engagementId, controlId, documentId} = props;
	const [showLoader, setShowLoader] = useState(true),
		[selectedFrequencyType, setSelectedFrequencyType] = useState(''),
		[activeITApproachTypeId, setActiveITApproachTypeId] = useState(''),
		[activeOperatingEffectivenesIndex, setActiveOperatingEffectivenesIndex] = useState(''),
		[activeControlTestingIndex, setActiveControlTestingIndex] = useState('');

	const itcontrolDetails = useSelector((store) => store.itcontrolDetails);
	const dispatch = useDispatch();

	//Fill control Object
	const fillControlObject = () => {
		let controlTesting = null;
		if (activeControlTestingIndex) {
			controlTesting = activeControlTestingIndex === 1;
		}
		let controlIsEffective = null;
		if (activeOperatingEffectivenesIndex) {
			controlIsEffective = activeOperatingEffectivenesIndex === 1;
		}

		let data = {
			controlFrequencyTypeId:
				selectedFrequencyType && selectedFrequencyType.value !== -1 ? selectedFrequencyType.value : null,
			itApproachTypeId: activeITApproachTypeId,
			isEffective: controlIsEffective,
			hasControlTesting: controlTesting
		};
		ADCContainerRef.current.selectedControl = data;
	};
	// Save frequency type
	const onControlFrequencyType = (option) => {
		setSelectedFrequencyType(option);
	};

	// Save DesignEffectiveness
	const toggleApprochType = (e) => {
		setActiveITApproachTypeId(Number(e.currentTarget.id));
	};

	// Save OpertaingEffectiveness type
	const toggleOpertaingEffectivenessClick = (e) => {
		let selectedOperatingId = Number(e.currentTarget.id);
		selectedOperatingId !== activeOperatingEffectivenesIndex
			? setActiveOperatingEffectivenesIndex(selectedOperatingId)
			: setActiveOperatingEffectivenesIndex('');
	};

	// Save Control Testing type
	const toggleTestingClick = (e) => {
		let selectedTestingId = Number(e.currentTarget.id);
		selectedTestingId !== activeControlTestingIndex
			? setActiveControlTestingIndex(selectedTestingId)
			: setActiveControlTestingIndex('');
	};

	const formatSelectedLabel = ({label}) => {
		return (
			<section className="selectText">
				<EllipseControl id="formatControlLabel" content={label} tooltip={label} noOfLines={1} />
			</section>
		);
	};

	useEffect(() => {
		if (!showLoader) {
			// design effectiveness
			if (itcontrolDetails && itcontrolDetails.itApproachTypeId) {
				setActiveITApproachTypeId(itcontrolDetails.itApproachTypeId);
			}

			// Frequency
			if (itcontrolDetails && itcontrolDetails.controlFrequencyTypeId) {
				currentResource.controlFrequencyType.map((item) => {
					if (item.value === itcontrolDetails.controlFrequencyTypeId) {
						setSelectedFrequencyType(item);
					}
				});
			} else {
				setSelectedFrequencyType({value: -1, label: labels.SelectFrequency, title: labels.SelectFrequency});
			}

			// operating effectiveness
			if (itcontrolDetails && itcontrolDetails.isEffective !== null) {
				if (itcontrolDetails.isEffective) {
					setActiveOperatingEffectivenesIndex(1);
				} else {
					setActiveOperatingEffectivenesIndex(2);
				}
			}

			// testing
			if (itcontrolDetails && itcontrolDetails.hasControlTesting !== null) {
				itcontrolDetails.hasControlTesting ? setActiveControlTestingIndex(1) : setActiveControlTestingIndex(2);
			}
		}
	}, [itcontrolDetails, showLoader]);

	useEffect(() => {
		dispatch(getITControlById(engagementId, controlId, documentId))
			.then(() => {
				setShowLoader(false);
			})
			.catch(() => {
				setShowLoader(false);
			});
	}, []);

	return (
		<StyledEditControlWrapper className="StyledEditControlWrapper">
			{showLoader ? (
				<LoadingIndicator show view="blockview" styleName="LoadingIndicator" />
			) : (
				<>
					<section className="controlRow editITControl">
						<section className="editITControlApproachBtn">
							<section className="">{labels.approch}</section>
							<ContentSwitcher
								children={currentResource.itApproachType.map((data, index) => {
									return (
										<Button
											name={data.ITApproachTypeName}
											onClick={toggleApprochType}
											id={data.ITApproachTypeId}
											variant="secondary"
											className={`${activeITApproachTypeId === index + 1 ? 'motif-active' : ''}`}
											disabled={isShared}
											showLabel
											isEllipsed
											buttonLabel={data.ITApproachTypeName}
											noOfLines={1}
										/>
									);
								})}
							/>
						</section>
						{activeITApproachTypeId === itControlApproachType.controls && (
							<section className="editITControlFrequency">
								<ReactSelect
									formLabel={labels.frequency}
									formatOptionLabel={formatSelectedLabel}
									groupHeading
									id="ControlFrequencyType"
									isSearchable
									defaultValue={selectedFrequencyType}
									options={currentResource.controlFrequencyType}
									onChange={onControlFrequencyType}
									value={selectedFrequencyType}
									noOptionsMessage={() => labels.noResultsFound}
									isDisabled={isShared}
									theme={Utility.getTheme()}
								/>
							</section>
						)}
					</section>
					<section className="controlRow editITControlWrapper">
						<section className="editITControlEffectiveness">
							<section className="">
								<EllipseControl
									content={labels.controlOpertaingEffectiveness}
									tooltip={labels.controlOpertaingEffectiveness}
									noOfLines={1}
								/>
							</section>
							<ContentSwitcher
								children={currentResource.controlEffectivenessType.map((data, index) => {
									return (
										<Button
											name={data.ControlEffectivenessTypeName}
											onClick={toggleOpertaingEffectivenessClick}
											id={data.ControlEffectivenessTypeId}
											variant="secondary"
											className={`${activeOperatingEffectivenesIndex === index + 1 ? 'motif-active' : ''}`}
											disabled={isShared}
											showLabel
											isEllipsed
											buttonLabel={data.ControlEffectivenessTypeName}
											noOfLines={1}
										/>
									);
								})}
							/>
						</section>
						<section className="editITControlTesting">
							<section className="">
								<EllipseControl content={labels.testingTitle} tooltip={labels.testingTitle} noOfLines={1} />
							</section>
							<ContentSwitcher
								children={currentResource.testing.map((data, index) => {
									return (
										<Button
											name={data.testingDescription}
											onClick={toggleTestingClick}
											id={data.testingId}
											variant="secondary"
											className={`${activeControlTestingIndex === index + 1 ? 'motif-active' : ''}`}
											disabled={isShared}
											showLabel
											isEllipsed
											buttonLabel={data.testingDescription}
											noOfLines={1}
										/>
									);
								})}
							/>
						</section>
					</section>
					{fillControlObject()}
				</>
			)}
		</StyledEditControlWrapper>
	);
}

export default EditITControlContainer;

const StyledEditControlWrapper = styled.section`
	.editITControl {
		display: flex;
		align-items: flex-end;
		.editITControlApproachBtn {
			display: inline-block;
			margin-right: var(--px-20);
			.motif-content-switcher {
				button {
					.ellipses {
						justify-content: center;
					}
				}
			}
		}
		.editITControlFrequency {
			display: inline-block;
			width: var(--px-360);
			.css-b8ldur-Input {
				padding: 0 !important;
				margin: 0 !important;
			}
		}
	}
	.editITControlWrapper {
		display: inline-block;
		margin-top: var(--px-20);
		.editITControlEffectiveness {
			display: inline-block;
			margin-right: var(--px-20);
		}
		.editITControlTesting {
			display: inline-block;
			margin-right: var(--px-20);
		}
	}
`;
